import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import clsx from "clsx";
import { useCallback } from "react";

function FerrySearchTabs({ activeTab = "oneway", setActiveTab }) {
  const t = useTranslationDetector();

  const handleTabClick = useCallback(
    (tabId) => {
      setActiveTab(tabId);
    },
    [setActiveTab],
  );

  return (
    <div className="rounded-xl border border-white bg-white/60 p-[6px] shadow-[0_8px_42px_0_rgba(0,0,0,0.10)] backdrop-blur-xl md:border-none md:bg-white/0 md:p-0 md:shadow-none md:backdrop-blur-none">
      <div className="relative flex justify-between gap-0 font-medium md:inline-flex md:w-auto md:justify-start md:gap-4 rtl:flex-row-reverse">
        {/* Mobile sliding background */}
        <span
          className={clsx(
            "bg-primary absolute top-0 left-0 h-full w-1/2 rounded-md transition-all duration-500 ease-in-out md:hidden",
            activeTab === "oneway" && "left-0",
            activeTab === "roundtrip" && "left-1/2",
          )}
        />

        {/* One Way */}
        <button
          className={clsx(
            "relative inline-flex w-1/2 cursor-pointer items-center justify-center gap-2 rounded-md py-2 text-center transition-all duration-200 ease-in-out md:w-auto md:justify-start md:py-0 md:text-left",
            activeTab === "oneway" && "md:text-foreground text-white",
          )}
          onClick={() => handleTabClick("oneway")}
        >
          <span
            className={clsx(
              "relative hidden h-6 w-6 rounded-full border transition-all duration-200 ease-in-out md:block",
              activeTab === "oneway"
                ? "bg-primary border-primary"
                : "border-primary-weak bg-white",
            )}
            style={
              activeTab != "oneway"
                ? {
                    border: "1px solid var(--color-primary-weak)",
                  }
                : {}
            }
          >
            <span
              className={clsx(
                "absolute top-1/2 left-1/2 h-0 w-0 origin-center -translate-x-1/2 -translate-y-1/2 rounded-full bg-white transition-all duration-200 ease-in-out",
                activeTab === "oneway" && "h-2 w-2",
              )}
            />
          </span>
          <span className="text-sm">{t("ferry.oneWay")}</span>
        </button>

        {/* Round Trip */}
        <button
          className={clsx(
            "relative inline-flex w-1/2 cursor-pointer items-center justify-center gap-2 rounded-md py-2 text-center transition-all duration-200 ease-in-out md:w-auto md:justify-start md:py-0 md:text-left",
            activeTab === "roundtrip" && "md:text-foreground text-white",
          )}
          onClick={() => handleTabClick("roundtrip")}
        >
          <span
            className={clsx(
              "relative hidden h-6 w-6 rounded-full border transition-all duration-200 ease-in-out md:block",
              activeTab === "roundtrip"
                ? "bg-primary border-primary"
                : "border-primary-weak bg-white",
            )}
            style={
              activeTab != "roundtrip"
                ? {
                    border: "1px solid var(--color-primary-weak)",
                  }
                : {}
            }
          >
            <span
              className={clsx(
                "absolute top-1/2 left-1/2 h-0 w-0 origin-center -translate-x-1/2 -translate-y-1/2 rounded-full bg-white transition-all duration-200 ease-in-out",
                activeTab === "roundtrip" && "h-2 w-2",
              )}
            />
          </span>
          <span className="text-sm">{t("ferry.roundTrip")}</span>
        </button>
      </div>
    </div>
  );
}

export default FerrySearchTabs;
